$(document).ready(function(){
  if($("#purchase").length >= 1){
   var qtyavail_t = $("span.qtyavailable").text();
   var qtyavail = qtyavail_t.replace( /^\D+/g, '');
   //console.log(qtyavail);
   
    $("input#quantity").change(function(){
      checkQTY($(this), qtyavail);
    });
    $("input#quantity").on('keyup', function(){
      checkQTY($(this), qtyavail);
    });
  	checkQTY($("input#quantity"), qtyavail);
   
  }
  function checkQTY(inputqty, avail){
    //console.log(parseInt(inputqty.val())+ ' : ' +parseInt(avail));
    if(parseInt(inputqty.val()) > parseInt(avail)){
      $("#add-to-cart").hide(); 
      showQTYmuch();
    } else {
      $("#purchase #showqtymuch").remove();
      $("#add-to-cart").fadeIn(); 
    }
  }
  function showQTYmuch(){
    if($("#showqtymuch").length >= 1){
      
    } else {
     $("#purchase").append('<span id="showqtymuch">Quantity not available.</span>'); 
    }
  }
});